import cx from 'classnames';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { cloneChildren } from '../../_utils';
export const BaseSegmentControl = (props) => {
    /** This is been done to check if the props is specific type */
    const { children, selectedIndex, onSelect = _.noop, disabled = false, widthAdjust = 0, classNames, type, segmentControlClassName, ...restProps } = props;
    const setInitialSelectedIndex = () => {
        if (type === 'FormFormatterControl') {
            return selectedIndex ? [...selectedIndex] : [0];
        }
        return [selectedIndex ? selectedIndex : 0];
    };
    // const [selected, setSelected] = useState(0);
    const [currentSelectedIndex, setCurrentSelectedIndex] = useState(setInitialSelectedIndex());
    const [selectedItemStyle, setSelectedItemStyle] = useState({});
    const controlStyles = cx(classNames.segmentedControl, {
        [classNames.disabled]: disabled,
    }, segmentControlClassName);
    const getCurrentTypeControl = useCallback(() => {
        if (type === 'FormFormatterControl') {
            return 'FormFormatterControl';
        }
        return 'SegmentControl';
    }, [type]);
    useEffect(() => {
        if (getCurrentTypeControl() === 'FormFormatterControl') {
            setCurrentSelectedIndex(selectedIndex ? [...selectedIndex] : []);
        }
        else {
            setCurrentSelectedIndex(selectedIndex ? [selectedIndex] : [0]);
        }
    }, [getCurrentTypeControl, selectedIndex]);
    const fontFormatterStateHandler = (index) => {
        let filteredOptions;
        if (currentSelectedIndex.indexOf(index) >= 0) {
            filteredOptions = currentSelectedIndex.filter((option) => option !== index);
            setCurrentSelectedIndex([...filteredOptions]);
        }
        else {
            filteredOptions = [...currentSelectedIndex, index];
            setCurrentSelectedIndex(filteredOptions);
        }
        const filteredOptionsAsKeys = filteredOptions.map((i) => children[i].key);
        onSelect(filteredOptionsAsKeys);
    };
    const isItemSelected = (index) => index === currentSelectedIndex[currentSelectedIndex.indexOf(index)];
    const onSelectHandler = (index, { width, offsetX }) => {
        if (!disabled) {
            if (getCurrentTypeControl() === 'FormFormatterControl') {
                fontFormatterStateHandler(index);
            }
            else {
                const selectedStyle = {
                    width: `${width - (widthAdjust || 0)}px`,
                    transform: `translateX(${offsetX}px)`,
                };
                setSelectedItemStyle(selectedStyle);
                setCurrentSelectedIndex([index]);
                onSelect(index);
            }
        }
    };
    return (React.createElement("div", { className: controlStyles, ...restProps, role: "tablist" },
        React.Children.toArray(children).map((segmentItem, index) => {
            const segmentItemProps = {
                index,
                isSelected: isItemSelected(index),
                onSelect: onSelectHandler,
            };
            return cloneChildren(segmentItem, segmentItemProps);
        }),
        getCurrentTypeControl() && (React.createElement("div", { className: 
            // this style has white background and if this is set before the
            // width is set, the whole segment will be in white color for few seconds
            (selectedItemStyle === null || selectedItemStyle === void 0 ? void 0 : selectedItemStyle.width)
                ? classNames.selectedHighlight
                : '', style: selectedItemStyle }, ' '))));
};
//# sourceMappingURL=base-control.js.map